import { useCallback, useEffect, useState } from 'react';
import { MAX_DISPLAY_ONBOARDING_COUNT } from '../../../constants/map';
import { useApplicationContext } from '../../../utils/withApplicationContext';
import { getIsOnboardingEnabled, getOnboardingViews, setOnboardingViews } from '../helpers/mapOnboarding';

export const useMapOnboardingState = (): [boolean, () => void] => {
  const [isOpen, setIsOpen] = useState(false);
  const { config } = useApplicationContext();

  const closeOnboarding = useCallback(() => {
    if (isOpen) {
      setIsOpen(false);
      setOnboardingViews(MAX_DISPLAY_ONBOARDING_COUNT);
    }
  }, [isOpen]);

  useEffect(() => {
    const displayCount = getOnboardingViews();
    const isOnboardingEnabled = getIsOnboardingEnabled(config);

    if (isOnboardingEnabled && displayCount < MAX_DISPLAY_ONBOARDING_COUNT) {
      setIsOpen(true);
      setOnboardingViews(displayCount + 1);
    }
  }, []);

  return [isOpen, closeOnboarding];
};
